import Actions                  from 'Redux/Actions';
import { SettingsRepository }   from 'Domain/Repositories';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { message }              from 'antd';

export const updateSettingsEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.updateSettingsRequest.type),
    mergeMap(action => from(SettingsRepository.updateOptions(action.payload.formData))
      .pipe(
        mergeMap(({ options }) => {
          message.success('Die Speicherung der ServerSettings war erfolgreich.');

          return from([
            Actions.updateSettingsSuccess({ options }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.updateSettingsFailure({ error })
          ]);
        })
      )
    ),
  );
};
